/* eslint-disable complexity */
import React from 'react';
import PropTypes from 'prop-types';
import VariationSelector from './VariationSelector';
import ProductAddOn from '../../../shared/components/ProductAddOn/ProductAddOn';
import { fetchProductVariation } from '../actions/product';
import QuantitySelector from '../../../shared/components/QuantitySelector/QuantitySelector';
import { fetchAddOns, receiveAddOnsResult } from '../actions/addOns';
import { fetchExternalAddOns, resetExternalAddOns } from '../../../shared/redux/actions/externalAddOns';
import CustomReactMarkdown from '../../../shared/components/MarkdownRenderers/CustomReactMarkdown';
import ExternalAddOnsContainer from '../../../shared/components/ExternalAddOns/ExternalAddOnsContainer';

// TODO consider lifiting methods and state to container
class AddToCartForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleDropownChange = this.handleDropownChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.showVariationHandler = this.showVariationHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitZipCode = this.submitZipCode.bind(this);
    this.getOptionsInputValue = this.getOptionsInputValue.bind(this);
    this.enableAddToCart = this.enableAddToCart.bind(this);
    const { product: { selectedQuantity }, largeApplianceAttributes: { isLargeAppliance } } = props;
    this.state = {
      quantity: selectedQuantity,
      isZipCodeSaved: isLargeAppliance? false : true,
      error: false,
      nonDeliverable: false,
      dateOfDelivery: null,
    };
    this.addToCartForm = React.createRef();
    this.submitZipCode = this.submitZipCode.bind(this);
  }

  componentDidMount() {
    this.getAddOns();
  }

  getAddOns() {
    const {
      dispatch,
      product: { getProductAddOnsUrl },
    } = this.props;

    const parsedUrl = new URL(getProductAddOnsUrl);
    const { product } = this.props;
    parsedUrl.searchParams.set('pid', product.id);
    dispatch(fetchAddOns(parsedUrl.toString()));
  }

  getOptionsInputValue() {
    const { addOns } = this.props;
    const values = addOns.map(({ optionId, checked, id, resetValue }) => ({
      optionId,
      selectedValueId: checked ? id : resetValue,
    }));

    return JSON.stringify(values);
  }

  handleQuantityChange(value) {
    this.setState({ quantity: value });
  }

  handleDropownChange(event, variationGroup) {
    const { value: selectedValue } = event.currentTarget;
    const variation = variationGroup.values.find(
      ({ value }) => value.toString() === selectedValue.toString()
    );

    this.showVariationHandler(variation);
  }

  submitForm() {
    this.addToCartForm.current.submit();
  }


  submitZipCode(zipCode, shouldSaveZipCode) {
    const {
      largeApplianceAttributes: { 
        getExternalAddOnsUrl,
        id: productID,
       },
    } = this.props;

    const { dispatch } = this.props;
    dispatch(fetchExternalAddOns(getExternalAddOnsUrl, zipCode, productID, shouldSaveZipCode));
  }

  handleSubmit(event) {
    event.preventDefault();

    const { quantity, zipCode } = this.state;
    const { product, analytics } = this.props;
    this.prevZipCode = zipCode;

    analytics.addToCart(product, quantity, this.submitForm);
  }

  async showVariationHandler({ url, selectable }) {
    const { dispatch, inFlight, product, largeApplianceAttributes } = this.props;

    if (!inFlight && selectable) {
      await dispatch(fetchProductVariation(url));
      this.getAddOns();
      if(largeApplianceAttributes && largeApplianceAttributes.isLargeAppliance) {
        dispatch(resetExternalAddOns(product.id));
      }
    }
  }

  toggleAddOn(addOnId) {
    const { addOns, dispatch, analytics } = this.props;
    let toggledAddOn;

    const updatedAddOns = addOns.map((addOn) => {
      if (addOn.id === addOnId) {
        toggledAddOn = {
          ...addOn,
          checked: !addOn.checked,
        };

        return toggledAddOn;
      }

      return addOn;
    });

    analytics.toggleAddOn(
      toggledAddOn.optionId,
      toggledAddOn.checked,
      'PDP',
      () => {
        dispatch(receiveAddOnsResult({ addOns: updatedAddOns }));
      }
    );
  }

  enableAddToCart() {
    let enableAddToCartButton = true;
    const {
      product: { 
        basketRestrictions: {
          enableAddToCart = true
        } = {}
      } = {},
      largeApplianceAttributes: {
        error = false
      }
    } = this.props;

    if (!enableAddToCart || error || !this.state.isZipCodeSaved) {
      enableAddToCartButton = false;
    }

    return enableAddToCartButton;
  }

  render() {
    const { quantity } = this.state;
    const {
      product,
      addOns,
      addOnRestriction,
      priceDisplay: { rebatePriceValue, priceValue, salesPriceValue, onSale },
      analytics,
      inFlight,
      item,
    } = this.props;
    const {
      id,
      addToCartUrl,
      maxOrderQuantity,
      minOrderQuantity,
      available,
      basketRestrictions: {
        hideQauntitySelector = false
      } = {}
    } = product;

    const {
      isLargeAppliance,
    } = this.props.largeApplianceAttributes;

    let buttonClass = '';
    let btnText = 'Add to cart';

    if (!available) {
      buttonClass = 'product-details__form-submit--disabled';
      btnText = 'Out of stock';
    }

    if(!this.enableAddToCart()) {
      buttonClass = 'product-details__form-submit--disabled ';
      btnText = 'Add to cart';
    }

    buttonClass = buttonClass + ' product-details__form-submit--right_align';

    const productPrice = isNaN(rebatePriceValue)
      ? onSale
        ? salesPriceValue
        : priceValue
      : rebatePriceValue;

    if (addOnRestriction) {
      return (
        <>
          <CustomReactMarkdown
            className="product-details__restricted-info"
            source={'This item cannot be added to your cart. [[ MarkdownTooltip title="Learn more" ]]'}
            tooltip={{ message: addOnRestriction }}
            renderers={{ paragraph: 'span' }}
          />
          <div className="product-details__restricted-button-container">
            <button
              type="button"
              disabled
              className="product-details__restricted-button"
            >
              {btnText}
            </button>
          </div>
        </>
      );
    }

    return (
      <form
        ref={this.addToCartForm}
        action={addToCartUrl}
        method="POST"
        onSubmit={this.handleSubmit}
        onKeyDown={this.handleKeyDown}
      >
        <input type="hidden" name="quantity" value={quantity} />
        <input type="hidden" name="pid" value={id} />
        <input
          type="hidden"
          name="options"
          value={this.getOptionsInputValue()}
        />
        {addOns.length > 0 && (
          <>
            <div className="product-details__addons">
              <div className="product-details__addons-label">
                Exclusive Offers
              </div>
              {addOns.map((addOn) => (
                <ProductAddOn
                  key={addOn.id}
                  uniqueId={addOn.id}
                  onChangeHandler={() => this.toggleAddOn(addOn.id)}
                  addOn={addOn}
                  isSelected={addOn.checked}
                  productPrice={productPrice}
                  isTile
                  analytics={analytics}
                  item={item}
                />
              ))}
            </div>
          </>
        )}
        <VariationSelector
          handleDropownChange={this.handleDropownChange}
          showVariationHandler={this.showVariationHandler}
          variationAttributes={product.variationAttributes}
          pendingRequest={inFlight}
        />
        {isLargeAppliance && (
          <>
            <div className="product-details__deliveryservices">
              <div className="product-details__deliveryservices-label">
                AVAILABLE SERVICES
              </div>
              <ExternalAddOnsContainer
                submitZipCode={this.submitZipCode}
                dispatch={this.props.dispatch}
                isZipCodeSaved={this.state.isZipCodeSaved}
                updateIsZipCodeSaved={value => this.setState({ isZipCodeSaved: value })}
                {...this.props.largeApplianceAttributes}
              />
            </div>
          </>
        )}

        <div className="product-details__form-row">
          { !hideQauntitySelector && (
            <fieldset className="product-details__quantity-fieldset">
              <legend className="product-details__quantity-title">
                Quantity
              </legend>
              <QuantitySelector
                current={quantity}
                min={minOrderQuantity}
                max={maxOrderQuantity}
                onChange={(value) => this.handleQuantityChange(value)}
                disabled={!available}
              />
            </fieldset>
          )}
          <input
            className={`product-details__form-submit ${buttonClass}`}
            type="submit"
            value={btnText}
            disabled={!available || !this.enableAddToCart()}
          />
        </div>
      </form>
    );
  }
}

AddToCartForm.propTypes = {
  addOns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      checked: PropTypes.bool,
      callToActionText: PropTypes.string,
    })
  ),
  addOnRestriction: PropTypes.string,
  product: PropTypes.shape({
    selectedQuantity: PropTypes.number,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        addOnId: PropTypes.string,
        selectedValueId: PropTypes.string,
      })
    ),
  }).isRequired,
  priceDisplay: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  inFlight: PropTypes.bool.isRequired,
  analytics: PropTypes.shape({}).isRequired,
  item: PropTypes.shape({}),
};

AddToCartForm.defaultProps = {
  addOns: [],
  addOnRestriction: null,
};

export default AddToCartForm;
